// External deps
import { useContext } from 'react';

// Internal deps
import { DetailsEventsModalContext } from '../context/DetailsEventsModalContext';

export default function useDetailsEventsModal() {
  return useContext(DetailsEventsModalContext);
}
